<template>
  <div>
    <!-- 头部轮播图 begin -->
    <a-row id="swiper_image_box">
      <a-col :span="24">
        <div class="slider-banner banner">
          <swiper :options="swiperOption" v-if="banners.length > 0">
            <swiper-slide v-for="(item, index) in banners" :key="index">
              <img @mouseenter="enter()" @mouseleave="leave()" :src="item" />
            </swiper-slide>
            <div
              class="swiper-pagination paginationBanner"
              slot="pagination"
            ></div>
            <div
              :style="{
                display: blockPevAndNextBtn == true ? 'block' : 'none',
              }"
              class="swiper-button-prev"
              slot="button-prev"
            ></div>
            <div
              :style="{
                display: blockPevAndNextBtn == true ? 'block' : 'none',
              }"
              class="swiper-button-next"
              slot="button-next"
            ></div>
          </swiper>
        </div>
      </a-col>
    </a-row>
    <!-- 头部轮播图 begin -->

    <!-- 关于我们 begin -->
    <div class="about_box acea-row row-column row-center-wrapper">
      <div class="acea-row row-column row-center-wrapper top_big_small_box">
        <div class="about_top_box acea-row row-middle">
          <div class="gary_text">OUR</div>
          <div class="primary_color_text">COMPANY</div>
        </div>
        <div class="top_text_box_two">关于我们</div>
      </div>
      <div class="meddile_audio_conten acea-row row-column row-center-wrapper">
        <video loop="loop" :src="companyVdio" autoplay="autoplay" controls class="vdio"></video>
      </div>
      <div class="bottom_company_content acea-row row-center-wrapper">
        <div id="logo_header" class="acea-row row-column-between">
          <img class="logo" src="@/assets/company_logo_icon.png" />
          <div class="logo_bottom_text">——广东庞盛科技有限公司——</div>
        </div>
        <div class="contentText">
          广东庞盛科技有限公司是一家深耕智慧用电与保护行业的高新技术企业，以智慧用电整体建设为目标、集物联网管理、工业物联、大数据等新技术，为用户提供咨询规划软件研发、硬件配套、运维系统的整体解决方案供应商。
        </div>
      </div>
    </div>
    <!-- 关于我们 end -->

    <!-- 图标界限 begin -->
    <div class="about_com_icon_list_box acea-row row-center-wrapper">
      <div v-for="(item, index) in iconInfoList" :key="index" class="item_box">
        <img class="icon" :src="item.icon" />
        <div class="acea-row">
          <div class="text">{{ item.text }}</div>
          <span class="texteg">{{ item.texteg }}</span>
        </div>
      </div>
    </div>
    <!-- 图标界限 end -->

    <!-- 产品系列 begin -->
    <div class="acea-row row-column row-center-wrapper top_big_small_box">
      <div class="about_top_box acea-row row-middle">
        <div class="gary_text">OUR</div>
        <div class="primary_color_text">PRODUCTS</div>
      </div>
      <div class="top_text_box_two">产品系列</div>
    </div>
    <div class="acea-row row-center-wrapper">
      <div style="width: 60%; margin-top: 0px" class="contentText">
        广东庞盛科技有限公司是一家深耕智慧用电与保护行业的高新技术企业，以智慧用电整体建设为目标、集物联网管理、工业物联、大数据等新技术，为用户提供咨询规划软件研发、硬件配套、运维系统的整体解决方案供应商。
      </div>
    </div>
    <!-- 产品系列 end  -->

    <!-- PC 产品swiper begin-->
    <div class="PC_mainProductSwiperComp">
      <mainProductSwiper :mainProductList="mainProductList"></mainProductSwiper>
    </div>
    <!--PC 产品swiper end-->

    <!-- MObile 产品swiper begin-->
    <div class="MObile_mainProductList_box acea-row row-column">
      <div
        v-for="(item, index) of mainProductList"
        :key="index"
        class="item_box row-middle acea-row row-center"
      >
        <div

          class="img"
          :style="`backgroundImage: url(` + item.url + `)`"
        ></div>
        <div class="info_box">
          <div class="name">{{ item.text }}</div>
          <div  class="btn">点击查看 ></div>
        </div>
      </div>
    </div>
    <!-- MObile 产品swiper end-->
    <div class="model_application">
      <!-- 应用领域 begin -->
      <div class="acea-row row-column row-center-wrapper top_big_small_box">
        <div class="about_top_box acea-row row-middle">
          <div class="gary_text">OUR</div>
          <div class="primary_color_text">APPLICATION AREA</div>
        </div>
        <div class="top_text_box_two">应用领域</div>
      </div>
      <div class="acea-row row-center-wrapper">
        <div style="width: 60%; margin-top: 0px" class="contentText">
          全系列产品由自动重合闸系列、电源防护系列、电源控制系列、智慧用电管理终端四大系列组成功能涵盖了雷击保护、雷击计数、过流\短路保护、漏电保护、欠压\失压保护、过压保护、数据通讯、故障记忆电网监控与显示、合闸前检测、定时控制、自动重合装置等智能控制功能
        </div>
      </div>
      <!-- 应用领域 end  -->
      <div class="imgs_box acea-row">
        <div
          :style="`backgroundImage: url(` + item.image + `)`"
          v-for="(item, index) in model_applicationList"
          :key="index"
          class="item"
        >
          <div class="tit_box">
            {{ item.title }}
          </div>
        </div>
      </div>
    </div>
    <div
     @click="gotoSlejiejueEdit()"
      class="mall_small_Image_box acea-row row-center-wrapper row-column"
      :style="`backgroundImage: url(` + mall_small_Image + `)`"
    >
      <div class="title">行 业 应 用 解 决 方 案</div>
      <div class="select_btn">点击查看</div>
    </div>

    <!-- 新闻资讯 begin -->
    <div class="acea-row row-column row-center-wrapper top_big_small_box">
      <div class="about_top_box acea-row row-middle">
        <div class="gary_text">OUR</div>
        <div class="primary_color_text">NEWS AND INFOMATION</div>
      </div>
      <div class="top_text_box_two">新闻资讯</div>
    </div>
    <div class="news_list_box row-center-wrapper row-column acea-row">
      <div class="info_top acea-row">
        <div
          :style="`backgroundImage: url(` + newsList[0].image + `)`"
          class="new_one_image"
        ></div>
        <div class="info row-column acea-row">
          <!-- <div class="acea-row row-bottom row-between info_title_one">
            <div class="big_title">最新资讯</div>
            <div class="small_title">MORE</div>
          </div> -->
          <div  @click="sleNewEdit($event,newsList[0].title)" class="content_box acea-row row-column">
            <div class="title">{{ newsList[0].title }}</div>
            <div class="time">{{ newsList[0].time }}</div>
            <div class="content">{{ newsList[0].content }}</div>
          </div>
        </div>
      </div>
      <div class="row-middle acea-row row-between all_news_box">
        <div
          v-for="(item, index) in filterNews"
          :key="index"
          @click="sleNewEdit($event,item.title)"
          class="content_box_btm acea-row row-column"
        >
          <div>
            <div class="title">{{ item.title }}</div>
            <div class="time">{{ item.time }}</div>
            <div class="content">{{ item.content }}</div>
            <div class="more">MORE</div>
          </div>
        </div>
      </div>
      <div class="info_bottom"></div>
    </div>
    <!-- 新闻资讯 end  -->

    <!-- 合作伙伴 begin -->
    <div class="acea-row row-column row-center-wrapper top_big_small_box">
      <div class="about_top_box acea-row row-middle">
        <div class="gary_text">OUR</div>
        <div class="primary_color_text">PARTNERS</div>
      </div>
      <div class="top_text_box_two">合作伙伴</div>
    </div>
    <div class="cooperLartneList_box acea-row row-middle row-between">
      <div
        class="img"
        :style="`backgroundImage: url(` + item.src + `)`"
        v-for="(item, index) in cooperLartneList"
        :key="index"
      ></div>
    </div>
    <!-- 合作伙伴 end -->
  </div>
</template>
<script>
// 引入插件
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "@/assets/css/swiper.min.css";
import MainProductSwiper from "@/components/MainProductSwiper";
export default {
  name: "Index",
  components: {
    swiper,
    swiperSlide,
    mainProductSwiper: MainProductSwiper,
  },
  methods: {
    enter: function () {
      this.blockPevAndNextBtn = true;
    },
    leave: function () {
      this.blockPevAndNextBtn = false;
    },
    /**
     * 查看解决方案
     */
    gotoSlejiejueEdit:function(){
      console.log("点击查看")
          this.$router.push({path:'/KwhProgramme'});
    },
    /**
     *  查看新闻详情
     *
     */
    sleNewEdit:function(e,title){
        console.log("查看新闻详情",title);
         this.$router.push({path:'/NewEdit',query:{title:title}});
    }
  },
  mounted() {},
  data() {
    return {
      mainProductList: [
        {
          url: require("@/assets/main/products/way_one_main.png"),
          text: "单相重合闸系列",
          path:"/SingleProduct"
        },
        {
          url: require("@/assets/main/products/way_three_main.png"),
          text: "三相重合闸系列",
          path:"/ThreePaseProduct"
        },
        {
          url: require("@/assets/main/products/mind_control_main.png"),
          text: "智能控制系列",
          path:"/MonitorProduct"
        },
        {
          url: require("@/assets/main/products/mind_kwh_main.png"),
          text: "智慧用电管理终端",
          path:"/KwhProduct"
        }

      ], //商品列表
      // companyVdio:  require("../assets/tesevidio.mp4"),
      companyVdio: require("@/assets/tesevidio.mp4"),
      blockPevAndNextBtn: false, //是否显示轮播图的上一张下一张按钮
      isMobile: false, //是否为移动端
      //头部轮播图的swiper 配置项 begin
      swiperOption: {
        pagination: {
          el: ".paginationBanner",
          clickable: true,
        },
        autoplay: {
          delay: 3000,
          grabCursor: true,
          disableOnInteraction: true, //用户操作swiper之后，是否禁止autoplay。
        },
        navigation: {
          nextEl: ".swiper-button-next", //前进按钮的css选择器或HTML元素。

          prevEl: ".swiper-button-prev", //后退按钮的css选择器或HTML元素。

          hideOnClick: true, //点击slide时显示/隐藏按钮

          disabledClass: "my-button-disabled", //前进后退按钮不可用时的类名。

          hiddenClass: "my-button-hidden", //按钮隐藏时的Class
        },
        loop: true,
        speed: 1000,
        observer: true,
        observeParents: true,
        on: {
          tap: function () {
            // const realIndex = this.realIndex;
            // vm.goUrl(realIndex);
          },
        },
      },
      //头部轮播图的swiper 配置项 end

      //头部轮播图数据 begin
      banners: [
        "http://www.zhdk01.com/images/official_website/banner_home_4.png",
        "http://www.zhdk01.com/images/official_website/banner_home_2.png",
        "http://www.zhdk01.com/images/official_website/banner_home_4.png",
        "http://www.zhdk01.com/images/official_website/banner_home_2.png",
      ],
      //头部轮播图数据 end
      //图标信息list
      iconInfoList: [
        {
          icon: require("@/assets/main/main_model1_icon01.png"),
          text: "设计",
          texteg: " · design",
        },
        {
          icon: require("@/assets/main/main_model1_icon02.png"),
          text: "生产",
          texteg: " · production",
        },
        {
          icon: require("@/assets/main/main_model1_icon03.png"),
          text: "研发",
          texteg: " · R&D",
        },
        {
          icon: require("@/assets/main/main_model1_icon04.png"),
          text: "销售",
          texteg: " · marketing",
        },
        {
          icon: require("@/assets/main/main_model1_icon05.png"),
          text: "运营",
          texteg: " · Operation",
        },
      ],
      //应用领域list
      model_applicationList: [
        {
          image: require("@/assets/main/application/application_1.jpg"),
          title: "智慧校园",
        },
        {
          image: require("@/assets/main/application/application_2.jpg"),
          title: "智慧用电",
        },
        {
          image: require("@/assets/main/application/application_3.jpg"),
          title: "充电桩",
        },
        {
          image: require("@/assets/main/application/application_4.jpg"),
          title: "通讯基建",
        },
        {
          image: require("@/assets/main/application/application_5.jpg"),
          title: "视频监控",
        },
        {
          image: require("@/assets/main/application/application_6.jpg"),
          title: "智慧农业",
        },
        {
          image: require("@/assets/main/application/application_7.jpg"),
          title: "路灯照明",
        },
        {
          image: require("@/assets/main/application/application_8.jpg"),
          title: "智能交通",
        },
      ],
      mall_small_Image: require("@/assets/main/main_small_bg1.png"),
      //新闻资讯List
      newsList: [
        {
          image: require("@/assets/main/news/NewsImage1.png"),
          title: "物联网大发展将带动实体经济大发展",
          time: "2023-07-07",
          content:
          `党的二十大报告提出，加快发展数字经济，促进数字经济和实体经济深度融合，打造具有国际竞争力的数字产业集群。以新一代信息通信技术为主要手段的物联网，作为新型基础设施的重要组成部分已深入千行百业，正在为数字经济发展注入强劲动力。

在7月3日举行的“2023世界物联网500强峰会”上，伴随着2023世界物联网500强排行榜的对外发布，物联网与数字经济关系、市场构建、产业体系发展的重要性等话题亦成为与会委员、专家热议的焦点。

成绩斐然助力数字经济繁荣

近年来，我国物联网基础设施建设扎实推进，产业发展良好，融合应用百花齐放、硕果累累。

在基础设施建设与产业发展方面，窄带物联网、4G5G与固定宽带协同发展，基本实现城乡普遍覆盖和重点场景深度覆盖。在融合应用实践方面，国内各类企业依托网络创新应用、物联网操作系统、物联网平台等技术（服务），探索工业互联、智慧农业(3.410, -0.08, -2.29%)、智能家居等应用新模式，变革生产和生活方式，成效显著。`,
        },
        {
          image: require("@/assets/main/news/NewsImage2.png"),
          title: "电镀行业警钟鸣 污水治理要先行",
          time: "2020-09-17",
          content: `

电镀行业，是我国平面处理行业中一个主要的引导产业，同样中国也是世界的电镀大国，产业的发展离不开企业的支持，企业的发展离不开群众的支持。电镀的生产工艺中，需要用到大量的化学原料和水资源，就在生产工艺的背后，一个一直困扰不少人和企业的问题-“污水治理”，一直很让人揪心，国家不断的强化污水的治理法规，有的企业在配合国家的政策，但是有的企业却抱以“道高一尺，魔高一丈”的心态，不断钻法律的空子，想方设法的偷排污水，给国家和人民群众的生活带来了不小的灾害。

偷排的污水直接灌入农田

触目惊心的画面

环境保护，污水治理的问题，已经是一个跟我们生活息息相关的话题了，有不少国内的企业以身作则，花了大笔的资金对生产污水进行处理，有始有终才可以让一个企业更好的发展，如果一个企业只是一味的挣钱发展，而对于生产背后的垃圾置之不理，最后导致残害民生的话，等待这个企业的不仅仅是法律的制裁，更多的是人们群众的指责。作为一个世界上的电镀大国，如果我们不为电镀行业污水治理开一个好头，无论电镀行业在中国如何发展，相比欧美国家都会有一定差距，技术的差距可以克服，但是污染的治理我们应该如何克服呢。

措施一：整治小电镀等重污染企业取缔水源保护区一切排污口

近年来，各地纷纷加强电镀等企业污染整治，各地环保专项行动层出不穷。据悉，哈尔滨将进一步加强松花江流域电镀污染治理；淡水河流域内所有电镀企业整合入园；2013年年底前，花都将关闭或转移区内所有电镀企业；中山市编制电镀等重污染行业统一规划、统一定点实施方案；自2007年以来，惠阳和大亚湾在淡水河流域共限期治理企业36家，关停企业22家；银川市年内将对国家限期淘汰落后产能和已明令淘汰的小炼铁、小电镀、小造纸等高能耗企业全面清查拆除。

污水处理设施

措施二：加快产业结构和布局调整,推进清洁生产，提升工业污染防治水

电镀污水处理中心的兴建也为电镀企业降低污染，清洁生产走出了一条示范的道路。鄱阳县在全省县一级工业园区率先建成电镀污水处理中心，淘汰了９个污染企业和６条落后生产线，万元生产总值综合能耗下降４％，化学需氧量和二氧化硫排放量分别下降４．５％和１１．３％；南安的新电镀集控中心也是个典型的循环经济项目，其中，电镀污水处理能力可达到8600吨/日。这些污水经国内最先进的污水处理技术——膜处理后，回收用水将达60%以上，每年减排电镀废水量达200万吨；集控中心每年还可回收金属镍50至60吨、铜100至120吨及部分六价铬、锌等重金属，回收价值高达1000多万元。

措施三：排污权有偿使用

最近，排污权的有偿使用也成了电镀企业关注的热点。江阴电镀等水污染企申购排污权热情不减。江阴市化工、钢铁、电镀、及其他生产经营过程中直接或间接经许可向环境排放化学需氧量的排污单位和全市经许可向环境排放二氧化硫的排污单位，都纳入了排污权有偿使用的范围。

具体收费标准是:排入集中式污水处理厂进行处理的排污单位，化学需氧量排放指标有偿使用收费标准为2600元/年·吨；直接向环境排放污染物的排污单位，化学需氧量有偿使用收费标准是4500元/年·吨。

污水处理设施

措施四：加快推动环保电镀园区的建设

据悉：惠州市正在大力推动电镀园区的建设，将通过电镀行业的整合入园来全面清理整顿淡水河流域内所有电镀企业，目前，惠阳区政府已基本完成电镀园区选址工作，将于2010年底前按规定完成园区建设任务；广东阳江市政府要求当地的五金电镀企业于二0一0年年底完统一迁至市郊的环保工业城。目前，该环保工业城日处理污水量五千吨的污水处理厂首期主体工程已经完工；为保护泉州的“母亲河”晋江，南安仑苍电镀集控区正在加快异地搬迁步伐。从相关部门获悉，目前，新的电镀集控中心已完成投资1.98亿元，一期大部分安置厂房已封顶，污水处理厂工程将于6月底完工并进入调试运行。
`,
        },
        {
          image: require("@/assets/main/news/NewsImage3.png"),
          title: "全球安防产品出厂或达2340亿美元",
          time: "2020-09-17",
          content:
            `
相关数据统计显示，从2008年至今，全球电子安防市场以年均4.5%的增长率不断增长，成为全球经济不景气状况下的一抹亮色。据Memoori公司预测，2013年全球安防产品出厂总价值将高达2340亿美元，而且，在未来五年将保持8%的年均增长率，在2017年，将达到3220亿美元。

亚洲高端安防市场的需求已经成为全球电子安防市场增长的重要动力，到目前为止，占物理安全领域的份额已达39%，而欧洲、斯堪的纳维亚半岛和北美等发达市场虽然仍占总业务量的47%，却比去年减少了两个百分点。

不过，即便如此，中国物理安全产品的渗透率仍只有北美地区的1/6，在2013年，安防产品人均销售额仅为3.34美元，仍存在较大的增长空间。
`,
        },
        {
          image: require("@/assets/main/news/NewsImage4.png"),
          title: "解析中小企业安防市场现状及趋势",
          time: "2020-09-17",
          content:
            `国内安防中小企业“四面楚歌”

　　近年来，由于受到物价与原材料价格普遍上涨、人民币大幅升值、消费需求减弱、劳动力成本攀升及货币政策紧缩等诸多因素的影响，为数不少的中小企业已频临倒闭边缘：企业订单少、招工难、资金回笼慢、融资难。在国内安防企业中，中小型企业占绝大多数，毫无疑问也同样面临着同样的问题，据了解，受市场疲软的影响，国内部分中小安防企业已经接近“四面楚歌”的生存绝境。

　　转型：具备产业链资源整合能力

　　转型难：微利时代背景下安防中小企业现状中国安防行业历经30余年发展，市场已基本进入成熟阶段。随着各项新政策的不断出台，国家逐步加大对集团化、规模化、集约化大中型企业的整合力度，同时，传统行业如电子、生物等安防相关领域的龙头企业也渐渐卷入安防行业发展的大潮中。在这样双重夹击的背景下，中小型安防企业要想找到自己的生存法则，必须及早实现转型。

　　随着物联网技术的应用推广，网络化、高清化、智能化技术的不断成熟，安防企业已经不能再单一地定位于订单接洽、产品研发制造及销售服务环节了，而应注意整合安防企业上、中、下游的产业链资源，因为未来企业的竞争已不是企业规模、产能及产品的竞争，而是取决于企业能否具备产业链资源整合的核心能力。转型早、转型快、转型准的安防企业，相信已经尝到不少甜头，而目前仍然停留在传统手工作坊式、按订单生产等方式的企业必定会面临生存的困难。国内安防行业人力成本及营销成本节节攀升，产品价格却始终处于低端或低空区域;中小企业仍处于规模小、区域分布不均、综合竞争力不足及投融资渠道不够畅通的劣势，这些综合因素进一步加剧了安防中小企业转型难的困境。

　　市场风波带来毁灭性打击

　　2011年上半年，由于日本大地震的强烈冲击，一场前所未有电子产品提价风波影响全球。安防行业更是深受其害，由于传感器等核心部件由于多数为国外进口，所以随之涨价也是必然。同时，2011年DVR的大范围降价在整个安防行业可谓一石激起千层浪，引发了不少的震荡，受其直接影响的中小企业更似“惊弓之鸟”。市场竞争往往是现实的，也是残酷的，一波未平、一波又起，每一段市场风波，对身处艰难处境的中小安防企业来说，或许都是一次毁灭性的打击。

　　外资巨头和国内大企中夹缝生存

　　在这样的背景之下，有实力、有规模、资金流畅通的大中型安防企业可通过资源整合、产业升级、产品转型实现新的利润增长，保证企业的领先优势，但占安防行业绝大多数的中小企业却因规模小、综合实力弱、抗风险能力小等因素的局限，无法顺利或短时间内实现产业升级和转型，面对海内外市场的风云变幻，这些中小企业无论是资源、品牌还是在综合竞争力上均没有任何优势，随着人民币汇率波动的又一层打击，也让原本对价格优势抱有一丝幻想的中小企业濒临死亡边缘。人民币的升值将导致国内外安防产品竞争加剧，中小型安防企业只能选择在外资巨头和国内大规模集团化企业的夹缝中生存，由此可见，中国安防中小企业的生存空间和转型之路已变得越来越狭窄。

　　如何转“危”为“机”?

　　度危机：冷静应对，理性分析危机四伏更待柳暗花明，如何转“危”为“机”、谋求发展新出路，成为中小型安防企业面临并亟需解决的一个严肃而重要的课题。即使当前的市场环境恶劣复杂，我们仍能欣喜地看到，在困难中众多中小安防企业依然不断突破局限，努力坚持，改变生存法则。再大的企业也是从小企业开始做起来，无论前面的道路有多么艰难，安防中小企业都应该冷静分析，沉着应对，审时度势，寻求适合自己的生存之道。只有这样，企业才能存活下去，才能有健康长远的发展。中小企业依然占绝大多数，这是中国安防行业的现状也是安防企业的特性，对此我们不应只看到自己的劣势，同时也应看到自己的优势——麻雀虽小，五脏俱全。

　　作为企业的决策者及掌舵人，企业家更应摸清市场发展规律，顺应复杂外部环境，及时了解国家政策导向，在多变的市场竞争中寻求企业发展的新机遇。企业技术研发的新突破，产学研资源的充分整合，产品的转型升级，社会公共环境的市场需求及更为广泛的民用市场需求，都是安防企业可以努力去尝试并开拓的新蓝海。

　　民用安防带来生机

　　随时安防民用化的程度越来越高，安防产品走入寻常百姓家已成为不争的事实，如何抓住这个千载难逢的机遇，推动安防产品民用化，将成为安防中小企业实现跨越式发展的绝佳途径。如此说来，国内的安防企业特别是中小型安防企业只有夯实基础、打牢基本功，保持客观冷静心态，针对社会市场尤其是民用市场做多角度、深层次的分析，让自己的产品在竞争中占据更多的市场份额，为企业争取新的生存空间，除此以外，别无他途。求突围：转换思路，实现重生现代企业的竞争已经不再局限于传统意义上的产品、价格、渠道及市场等方面的竞争，而更多取决于新商业模式的竞争。

　　互联网、物联网引领新市场革命带来挑战和商机

　　随着互联网、物联网技术的不断成熟和应用推广，未来安防行业市场的竞争将不再是实体社会中的较量，而更多是在遍及全球的网络中进行。产品同质化、商业模式单一化将会使更多的安防中小企业面临生存发展的严峻挑战。终端客户消费习惯向互联网方向转变已渐成趋势，对此中小安防企业不应再聚集在单一营销层面，而应拓展多重营销模式，实现在新环境、新市场下的全面突围。随着信息技术的高速发展，拓展网络平台、实现新概念营销是企业生存发展的必经之路。互联网、物联网技术的综合应用推陈出新，必将引领一场新的市场革命，在这股浪潮的冲击下，国内安防中小企业能否抓住网络时代的发展机遇，创新营销模式，已成为企业发展转型的关键任务之一。令人担忧的是，目前国内大多数安防企业，无论是大型企业还是中小型企业均对互联网营销存有不同程度的陌生感与疑虑，对新商业模式不认同、不了解，对互联网、物联网等新平台不甚明白、无法接纳，甚至是一无所知。

　　“互联网”和“物联网”平台影响中小企业未来走向

　　中小安防企业如何牢牢掌握“互联网”和“物联网”两大创新平台，实现新营销模式的突破和创新，将直接影响中小安防企业未来的发展走向。观未来：开拓新兴市场是关键据行业统计数据显示，2010年我国安防行业产值将达到2270亿元的规模，北京奥运会、广州亚运会、上海世博会以及深圳大运会，都已经或即将进一步催生安防产业新的、更大的市场空间，也让安防产品的应用逐步拓展到更广泛的领域，被人们熟知或关注。

　　安防行业相关领域的高速发展，高科技、绿色节能模式的大范围推广和应用，以及高科技、多元化、数字化、集成化尖端产品的不断涌现，这一切都加速了安防市场的蓬勃发展。今天的中国，已俨然成为世界上最具规模、最具潜力和影响力的安防新兴市场，“中国制造”正向“中国创造”大踏步跨越，安防行业正进一步得到国家、社会和民众的高度重视，并成为国民经济新的经济增长点和战略性新兴产业之一。随着中央及地方各级政府对新兴产业的大力扶持，安防及相关产业中下游需求的强势拉动，安防产业综合竞争力的不断提升，社会民众消费能力以及安防意识的不断增强，国内安防产业也将从中受益。特别是在智能交通、教育、建筑、水利、医疗等多个领域，安防的重要性正得到更广泛的重视和关注，而网络、智能、高清等发展趋势则对安防企业提出了更高的要求。

　　总结

　　安防行业经过多年的市场培育和推广，在金融、公安、交通等传统行业已得到普遍性应用，建筑、电力、矿山、港口、教育及医疗等新兴安防应用行业对安防产品需求也呈快速增长趋势，而与此同时，随着百姓生活水平的提高，人们消费水平和结构发生了较大的变化，人们的自我保护和安全防范意识也有所改变，这也使得安防产品得到更广泛的应用。

来源：安防知识网`,
        },
      ],
      //合作伙伴List
      cooperLartneList: [
        { src: require("@/assets/main/lartneList/lartneList_img_1.png") },
        { src: require("@/assets/main/lartneList/lartneList_img_2.png") },
        { src: require("@/assets/main/lartneList/lartneList_img_3.png") },
        { src: require("@/assets/main/lartneList/lartneList_img_4.png") },
        { src: require("@/assets/main/lartneList/lartneList_img_5.png") },
        { src: require("@/assets/main/lartneList/lartneList_img_6.png") },
        { src: require("@/assets/main/lartneList/lartneList_img_7.png") },
        { src: require("@/assets/main/lartneList/lartneList_img_8.png") },
        { src: require("@/assets/main/lartneList/lartneList_img_9.png") },
        { src: require("@/assets/main/lartneList/lartneList_img_10.png") },
      ],
    };
  },
  computed: {
    filterNews: function () {
      let tempList = [];
      for (const key in this.newsList) {
        if (Object.hasOwnProperty.call(this.newsList, key)) {
          if (key <= 3 && key != 0) {
            tempList.push(this.newsList[key]);
          }
        }
      }
      return tempList;
    },
  },
};
</script>
<style scoped>
/* 轮播图 begin*/
.swiper_image_box {
  margin-bottom: 4%;
}
.slider-banner {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  margin-top: 40px;
}
.slider-banner .swiper-container {
  height: 100%;
}
.slider-banner img {
  display: block;
  width: 100%;
  height: auto;
}
.home_header_top_img {
  width: 100%;
  height: 600px;
  background-size: 100% 100%;
}
.swiperBox {
  width: 100%;
  position: relative;
}
.swiper_btn {
  position: absolute;
}
.swiper-button-prev {
  width: 60px;
  height: 60px;
  background: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC4AAAAuCAMAAABgZ9sFAAAAaVBMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACHh4f39/f5+fn4+Pj5+fn5+fn5+fn5+fn6+vr6+vr////SuEW8AAAAInRSTlMAAQIDBgcICQoMDQ4PEBESExQVFhcYGRoxxNDR0tPU2tzdoEnIjwAAARpJREFUSMelltuWgyAMRYOCrR0qCjZxrp32/z9yHnqHgGTNecQtC3I7AERSph/8jDj7oTcKilIbh/QkdJvCH9uZEoVtBjaeWHnD0XvKap/AzUQFTc0r3QYqyrcve6/QROF5/4lWNT1oSxWyN1pTlfQV93W4v+aS/7p8vEcrl/zyUVlO5684OgAAXY4+LfFiBwBDNU0DgMJqmlCxZ8nQRAZ2App24AQ0uTSMBZoCHAQ0HSAOzE+BJkzw7/OxhAsPI7yqMJBvsjSJiqCTlpiwgKXtIWy+bGv/frKtLRwcoLGGxttY4lLFpeiucZ0eRQPbNxI7CO1/zAZA2Wx80HLmqnNGqTPO2jM2PPcFl09NHlaeBZ0dL08IZ7vkzH/7UpbX365ndAAAAABJRU5ErkJggg==")
    no-repeat;
  background-size: 100% 100%;
}
.swiper-button-next {
  width: 60px;
  height: 60px;
  background: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC4AAAAuCAMAAABgZ9sFAAAAaVBMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACHh4f39/f4+Pj5+fn5+fn6+vr5+fn6+vr6+vr6+vr///9mQ76xAAAAInRSTlMAAQIDBgcICQoMDQ4PEBESExQVFhcYGRoxx9DR0tPU2dzdm4JKEwAAAR1JREFUSMelltt2wiAQRQ8JoLEYEoiMbe1F//8j+6C2yi3M6nlk7bAmczsAkYQaRreEsLhxUAJViY0N9KBgN5Uvtgsl8tsCrBxl5VSO3lNR+wTuZqpo7p7p3lNVrn+6e4Um8o/3z7Sq+Y821CBzpyU1Sd5w14a7Wy2j49e3Y56/1jfOysflnOc9AOj49Hgu8RrASM38CIhAzXwQaSw1XmFHDH4HSwzeotRcWd7jQAz+gEAV/hSnpoZ/Xd4TnBkM81eZiXzhlYnVBJrbYswG5o5HksrP6vAlo336ro42c3FAhhY63NdSoVRJiX41rdMTa2G7jmMHvv+P2QDCFPMTTM5cZckoZcFZh4wNL0PF5VOTx8qzQJvp+oSwRicx/wDzWZbXEoSK9AAAAABJRU5ErkJggg==")
    no-repeat;
  background-size: 100% 100%;
}
.swiper-pagination-bullet {
  width: 34px;
  height: 2px;
  background: #fff;
  opacity: 0.8;
  border-radius: 1px;
}
/* 轮播图 end*/

/* 关于我们 begin */
.top_big_small_box {
  margin-bottom: 4%;
  margin-top: 4%;
}
.top_big_small_box .about_top_box .gary_text {
  font-size: 42px;
  font-weight: bolder;
  color: #7f7f7f;
}
.top_big_small_box .about_top_box .primary_color_text {
  margin-left: 10px;
  color: #313493;
  font-size: 42px;
  font-weight: bolder;
}
.about_box .meddile_audio_conten .vdio {
  width: 100%;
  height: 100%;
}
.bottom_company_content {
  margin-top: 3%;
}
.about_box .bottom_company_content .logo {
  width: 240px;
  height: 70px;
}
.about_box .bottom_company_content .logo_bottom_text {
  color: #1d2088;
  font-size: 16px;
  padding: 0px 10px;
}
.top_big_small_box .top_text_box_two {
  color: #000000;
  font-size: 35px;
  margin-top: 10px;
  font-weight: bolder;
}
.contentText {
  color: #333333;
  font-size: 24px;
  width: 36%;
  margin-left: 2%;
}
/* 关于我们 end */

/* 图标界限 begin  */
.about_com_icon_list_box {
  width: 100%;
  background-color: #313493;
  padding: 40px 0px;
  margin: 4% 0px;
}
.about_com_icon_list_box .item_box {
  width: 13%;
  height: 180px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.about_com_icon_list_box .item_box .icon {
  width: 40px;
  height: 40px;

  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.about_com_icon_list_box .item_box .text {
  font-size: 22px;
  color: #fff;
  margin-top: 30px;
}
.about_com_icon_list_box .item_box .texteg {
  font-size: 22px;
  color: #fff;
  margin-top: 30px;
}
/*PC 横向swiper组件 */
.PC_mainProductSwiperComp {
  margin-top: 4%;
}
/*移动端 横向swiper组件 */
.MObile_mainProductList_box {
  width: 100%;
  margin-top: 10%;
  display: none;
}
.MObile_mainProductList_box .item_box {
  background-color: #e6e5e5;
  width: 100%;
  margin-bottom: 17%;
  height: 240px;
}
.MObile_mainProductList_box .item_box .img {
  width: 400px;
  height: 340px;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  margin-top: -50px;
}
.MObile_mainProductList_box .item_box .info_box {
  margin-left: 40px;
}

.MObile_mainProductList_box .item_box .info_box .name {
  font-size: 24px;
  color: #555555;
  font-weight: bold;
}
.MObile_mainProductList_box .item_box .info_box .btn {
  font-size: 20px;
  color: #555555;
}
/* 应用领域 begin*/
.model_application {
  background-color: #eee;
  padding: 3% 0px;
}
.model_application .imgs_box {
  margin: 3% 0%;
  justify-content: center;
}
.model_application .imgs_box .item {
  width: 20%;
  height: 18%;
  background-size: 100% 100%;
  margin: 10px;
}
.model_application .imgs_box .item .tit_box {
  padding: 10px;
  text-align: center;
  margin-top: 67%;
  color: white;
  font-size: 20px;
  background: rgba(0, 0, 0, 0.5);
}
/*应用领域 end  */

/* 中间的图 begin*/
.mall_small_Image_box {
  width: 100%;
  height: 180px;
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.mall_small_Image_box .title {
  color: #fff;
  font-weight: bolder;
  font-size: 32px;
}
/* 中间的图 end*/

.mall_small_Image_box .select_btn {
  background-color: #373738;
  border-radius: 5px;
  padding: 5px 20px;
  color: #fff;
  margin-top: 10px;
}

/* 新闻部分 begin */
.news_list_box {
  width: 100%;
}
.news_list_box .info_top {
  width: 75%;
  justify-content: center;
  background-color: #f6f6f6;
  padding-top: 30px;
}
.news_list_box .info_top .new_one_image {
  width: 55%;
  height: 350px;
  background-size: 100% 100%;
}
.news_list_box .info_top .info {
  width: 40%;
  margin-left: 40px;
}

.news_list_box .info_top .info .info_title_one .big_title {
  color: #333333;
  font-size: 35px;
  font-weight: bolder;
}

.news_list_box .info_top .info .small_title {
  color: #333333;
  font-size: 22px;
}
.news_list_box .info_top .content_box {
  margin-top: 4%;
}
.news_list_box .info_top .content_box .title {
  font-size: 30px;
  color: #333333;
  margin-bottom: 20px;
}
.news_list_box .info_top .content_box .time {
  font-size: 22px;
  color: #999999;
  margin-bottom: 20px;
}
.news_list_box .info_top .content_box .content {
  font-size: 22px;
  color: #666666;
  margin-bottom: 20px;
  border-bottom: 1px #bfbfbf solid;
  padding-bottom: 40px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
}
.news_list_box .all_news_box {
  width: 75%;
}
.news_list_box .all_news_box .content_box_btm {
  margin-top: 40px;
  width: 32.5%;
  background-color: #f6f6f6;
  padding: 30px 30px 10px 30px;
}
.news_list_box .all_news_box .content_box_btm .title {
  font-size: 24px;
  font-weight: bolder;
  color: #333333;
  margin-bottom: 20px;
}
.news_list_box .all_news_box .content_box_btm .time {
  font-size: 20px;
  color: #999999;
  margin-bottom: 20px;
}
.news_list_box .all_news_box .content_box_btm .content {
  font-size: 22px;
  color: #666666;
  margin-bottom: 20px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
}
.news_list_box .all_news_box .content_box_btm .more {
  font-size: 22px;
}
/* 新闻部分 end */

/* 合作伙伴 begin */
.cooperLartneList_box {
  width: 75%;
  margin: 0% 12.5%;
}
.cooperLartneList_box .img {
  width: 18%;
  height: 100px;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  margin: 20px 0px;
}
/* 合作伙伴 end */


@media screen and (max-width: 850px) {
  #logo_header {
    display: none;
  }
  .about_box .meddile_audio_conten .vdio {
    width: 80%;
  }
  .about_box .bottom_company_content .contentText {
    width: 80%;
  }
  .about_com_icon_list_box .item_box .texteg {
    display: none;
  }
  /* 隐藏产品swiper */
  .PC_mainProductSwiperComp {
    display: none;
  }
  /* 显示移动端 横向swiper组件 */
  .MObile_mainProductList_box {
    display: block;
  }
  /* 资讯column排列 */
  .news_list_box .info_top {
    flex-direction: column;
  }
  .news_list_box .info_top .new_one_image {
    width: 100%;
  }
  .news_list_box .info_top .info {
    width: 90%;
    margin-top: 40px;
  }
  .news_list_box .all_news_box {
    flex-direction: column;
  }
  .news_list_box .all_news_box .content_box_btm {
    width: 100%;
  }
  /* 合作伙伴 */
  .cooperLartneList_box .img {
    width: 30%;
  }
  /* 底部主页 */
  .main_bottom_box .top_senced_box {
    display: none;
  }
  .main_bottom_box .show_top_senced_box_moblie {
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home/Index.vue